export default __webpack_public_path__ + "static/media/nextarrow.b71907d1.svg";